export default function Footer() {
  return (
    <footer className="bg-primary text-white p-4 text-center">
      <div className="flex justify-center mb-2">
        <img 
          src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/56a40044976b9a3abcc586166eaf9251.jpeg" 
          alt="SunAce Logo" 
          title="SunAce - 確かな技術で安心をつくる"
          className="h-8"
        />
      </div>
      <p className="text-xs mb-2 text-green-100">確かな技術で安心をつくる</p>
      <div className="mt-3">
        <a 
          href="https://readdy.ai/?origin=logo" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-xs text-green-100 hover:text-white transition-colors"
        >
          愛知県岡崎市
        </a>
      </div>
    </footer>
  );
}
